import "./SectionInfo.css";

export const SectionInfo = () => {
    return (
        <div className="section-info container">
            <h2 className="provider-title">
                ¿Eres un profesional en el área de la salud?
            </h2>
            <div className="content">
                <img width={"100%"} src="/assets/images/portrait.jpg" alt="" />
                <div className="info">
                    <div className="box">
                        <h2>¡Registra tu información!</h2>
                        <p>Cuentanos mas sobre ti y nos pondremos en contacto lo antes posible.</p>
                        <button className="btn btn-primary">
                            Haz click aqui
                        </button>
                    </div>

                    <div className="box">
                        <h2>Ya soy cliente</h2>
                        <p>Inicia sesión en Vitaly y ponte en contacto con nosotros.</p>
                        <button className="btn btn-primary">
                            Iniciar sesion en Vitaly
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}